import styled from '@emotion/styled';
import Icon from '@mdi/react';
import { Variables } from '../../base';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Label = styled.div`
    font-size: 11px;
    font-weight: ${Variables.FontWeight.semibold};
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
    line-height: 1;
`;

export const MessageBox = styled.div`
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 8px;
    background: ${Variables.ThemeLight.Background3};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;

    &:focus-within {
        border-color: ${Variables.ThemeLight.PrimaryConstant6};
        box-shadow: 0 0 0 3px ${Variables.ThemeLight.PrimaryOpacity3};
    }
`;

export const InnerCol = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;

    textarea {
        resize: none !important;
        border: none !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        background: transparent !important;
        padding: 11px 12px !important;
        min-height: 96px;
        font-size: 14px !important;
        line-height: 1.5 !important;
        color: ${Variables.ThemeLight.TextStrong} !important;

        &:focus,
        &:active {
            border: none !important;
            box-shadow: none !important;
            outline: none !important;
        }
    }
`;

export const InputAttachments = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 0 12px 10px;
`;

export const DragOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Variables.Colors.nx16};
    color: ${Variables.Colors.b400};
    font-size: 16px;
    pointer-events: none;
    border-radius: 8px;
    z-index: 2;
`;

export const Latin1Error = styled.div`
    display: flex;
    align-items: center;
    color: ${Variables.Colors.warning};
    font-size: 13px;
    font-weight: 500;
    margin-top: 4px;
`;

export const Latin1ErrorIcon = styled(Icon)`
    fill: ${Variables.Colors.warning};
    margin-right: 4px;
`;
